export const posdevice = {
  seo: {
    title: 'Bistroo Device voor afhaal- en bezorgrestaurants',
    description: 'Het Bistroo Device is de ideale compacte handheld voor afhaal- en bezorgrestaurants, volledig geïntegreerd met jouw webshop, qr tafelbestelling of bestelzuil.',
  },
  hero: {
    title: {
      pt1: 'Een gebruiksklaar',
      pt2: 'Bistroo Device',
      pt3: 'voor online bestellingen',
    },
    description:
      'Het enige apparaat dat je nodig hebt om bestellingen te verwerken. Ontvangen, beheren en printen. Alles vanuit één draagbaar apparaat.',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Plug & play, serve all day',
      text: 'Geen ingewikkelde installatie of technische kennis vereist. Zet het simpelweg het apparaat gewoon aan en ga direct aan de slag. Begin binnen enkele minuten met het accepteren van je eerste bestelling.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_2: {
      title: 'Beheer, bevestig & print bestellingen',
      text: 'Verwerk bestellingen moeiteloos vanaf het apparaat, bevestig met één klik en geef handmatig de verwachte afhaal- of bezorgtijd door. Maak eenvoudig een terugbetaling op ieder gewenst moment. Geen extra printer nodig, alles is ingebouwd.',
      cta: '',
    },
    paragraph_3: {
      title: 'Update je shop op ieder moment',
      text: 'Sluit eenvoudig last-minute tijdsloten, zet producten tijdelijk op inactief en print snel je (dag)omzetoverzicht. Alles binnen handbereik, precies wanneer jij het nodig hebt.',
      cta: 'Verken de Bistroo pakketten',
    },
    paragraph_4: {
      title: 'Geen kabels, geen chaos',
      text: 'Volledig draadloos met een lange batterijduur, geen gedoe met kabels op jouw keukenvloer. Binnen of buiten, met WiFi en 4G kun je bestellingen op elke locatie accepteren. Je bent altijd online.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Ordermanagement.',
        text: 'Beheer je orders in real-time en behoud eenvoudig overzicht over alle processen.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Weet wat je verdient.',
        text: 'Bekijk je omzet voor een bepaalde periode met één simpele klik.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Tijd is in jouw handen.',
        text: 'Beheer je tijdsloten moeiteloos om knelpunten in de keuken te voorkomen en je workflow te optimaliseren.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Niet op voorraad, geen probleem.',
        text: 'Beheer je productvoorraad realtime met één klik.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Distributie-instellingen.',
        text: 'Wijzig je distributie-instellingen in real-time en pas ze snel aan.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"Bistroo denkt mee in oplossingen en nieuwe mogelijkheden."',
    cta: 'Lees volledig verhaal',
    name: 'Il Municipio',
    job_title: 'Italiaans Restaurant',
  },
  faq: {
    title_pt1: 'Alles over het',
    title_pt2: 'Bistroo Device',
    items: [
      { q: 'Wat is het Bistroo Device?', a: 'Het Bistroo Device is een compacte, draagbare handheld waarmee je bestellingen ontvangt, beheert en print. Het is het enige apparaat dat je nodig hebt om je online bestellingen volledig te verwerken.' },
      { q: 'Hoe snel kan ik beginnen met het Bistroo Device?', a: 'Het device is plug-and-play: zet het aan, verbindt met wifi en je ontvangt direct bestellingen. Geen installateur nodig, geen technische kennis vereist.' },
      { q: 'Heeft het Bistroo Device een ingebouwde printer?', a: 'Ja. De printer zit ingebouwd in het apparaat. Je hoeft geen aparte printer aan te sluiten. Elke bestelling print direct de gewenste bon voor de keuken of de klant.' },
      { q: 'Kan ik het device ook buiten of onderweg gebruiken?', a: 'Ja. Het apparaat werkt volledig draadloos via wifi en 4G. Je kunt bestellingen verwerken op het terras, bij een evenement of onderweg, altijd verbonden.' },
      { q: 'Hoe lang gaat de batterij mee?', a: 'De batterij is ontworpen voor een volledige werkdag. Bij drukke diensten raden we aan het device tussendoor op te laden via de meegeleverde lader.' },
      { q: 'Hoe bevestig ik een bestelling via het apparaat?', a: 'Wanneer een nieuwe bestelling binnenkomt, verschijnt deze direct op het scherm. Met één klik bevestig je de bestelling en geef je de verwachte afhaal- of bezorgtijd door aan de klant.' },
      { q: 'Kan ik tijdsloten en productvoorraad beheren via het device?', a: 'Ja. Via het apparaat sluit je snel tijdslots, zet je producten tijdelijk op inactief en pas je realtime je aanbod aan. Handig als een gerecht op is of als de keuken het even niet aankan.' },
      { q: 'Is het Bistroo Device te koppelen aan mijn webshop en kiosk?', a: 'Ja. Het device ontvangt bestellingen vanuit alle Bistroo-kanalen: je webshop, kiosk, QR-tafelbestelling en de Bistroo-bestelservice. Alles op één apparaat.' },
      { q: 'Hoe verwerk ik terugbetalingen via het device?', a: 'In het bestellingenoverzicht op het apparaat selecteer je de bestelling en kies je voor Terugbetaling. Het bedrag wordt direct teruggestort op de rekening van de klant.' },
      { q: 'Wat zijn de kosten van het Bistroo Device?', a: 'Het device is verkrijgbaar via huur of aankoop, gecombineerd met een Bistroo-softwarepakket. Neem contact op via bistroo.nl voor een actuele prijsopgave op maat.' },
    ],
  },
}
